import React, {Fragment} from 'react';
import * as ResourceApi from "api/resources";
import {FormattedMessage} from 'react-intl';
import {isNoU, platformCircledLetterClasses} from "utils/DBUtils";

export default {
    [ResourceApi.Types.Break]: (brk) => {
        let details = null;
        // Two ways to do this
        if (!isNoU(brk.resourceId) && brk.resourceId.type === ResourceApi.Types.Challenge) {
            // First is with a Challenge object, meaning we are deleting all of its platforms
            let platforms = Object.keys(brk.breaks).filter((platform) => platform !== "MASTER");
            let master = brk.breaks.MASTER;
            details = (
                <Fragment>
                    <FormattedMessage id={`modal.delete.break.permalink`} values={{permalink: master.permalink}}/>&nbsp;
                    {platforms.map((platform) => {
                        return (
                            <div key={platform} className={`circled-letter ${platformCircledLetterClasses[platform] || ''}`}/>
                        );
                    })}
                </Fragment>
            );
        } else {
            // Second is with an actual break object, just get permalink and platform
            details = (
                <Fragment>
                    <FormattedMessage id={`modal.delete.break.permalink`} values={{permalink: brk.permalink}}/>&nbsp;
                    <div className={`circled-letter ${platformCircledLetterClasses[brk.platform] || ''}`}/>
                </Fragment>
            );
        }
        return details;
    },

  [ResourceApi.Types.User]: (user, undelete) => (
      <FormattedMessage
        id={undelete ? 'modal.undelete.user.email' : 'modal.delete.user.email'}
        values={{email: user.email}} />
  )
};



// WEBPACK FOOTER //
// ./public/components/DeleteConfirmation/confirmationMessages.js